


























































































import moment from 'moment';
import { Text } from '@sitecore-jss/sitecore-jss-vue';
import MaturityBanners from '../subComponents/MaturityBanner/MaturityBanners.vue';
import AccountTable from '../subComponents/AccountTable/AccountTable.vue';
import LoadingBox from '../LoadingBox/LoadingBox.vue';
import { getPolicies, lastLogin, IPolicies, ILastLogin } from '../../api/index';
import { apiErrorHelper } from '../../api/apiErrorHelper';
import sortPolicies from '../../utils/sortPolicies';

export default {
  name: 'MyInvestmentsOverview',
  data() {
    return {
      // Retrieve the API Banner through API call  - will depends on cusomter ID
      apiBanners: null, // list of Banner retrieve from API - maybe on mounted...
      policies: [], // list of Policies retrieve from API - maybe on mounted...
      display: false,
      lastLogin: null,
      numberOfPolicies: 0,
      openPolicies: [],
      showClosedDisabled: true,
      showClosedUserChanged: false,
      showClosed: false,
      showAll: false,
      sortPolicies: sortPolicies,
      loading: true,
    };
  },
  props: {
    fields: {
      type: Object,
      default: () => ({}),
    },
  },
  async mounted() {
    try {
      const policies: IPolicies = await getPolicies();
      if (policies) {
        this.display = true;
        this.apiBanners = policies.maturityBanners;
        this.policies = policies.policyDetails;
        this.$store.commit('setPoliciesData', [...this.policies]);
        this.loading = false;
      }
    } catch (error) {
      this.loading = false;
      apiErrorHelper(this.$router, error);
    }
    try {
      const usersLastLogin: ILastLogin = await lastLogin();
      if (usersLastLogin.data && usersLastLogin.data.lastLogin) {
        this.lastLogin = moment(usersLastLogin.data.lastLogin);
      }
    } catch (error) {}
  },
  components: { AccountTable, MaturityBanners, ScText: Text, LoadingBox },
  computed: {
    contentBanners() {
      // This will get all Content for the possible Banners.
      if (this.fields) {
        return this.fields.Banners;
      }
      return null;
    },
    displayRBACashLinkedDisclaimer() {
      const rbaCashLinkedPolicies = this.policies.filter((policy) => policy.isRBACashLinked);
      return rbaCashLinkedPolicies.length > 0;
    },
    policiesToRender() {
      let policiesToRender = this.policies.sort(sortPolicies);
      this.openPolicies = policiesToRender.filter((policy) => policy.isActive);
      let closedPolicies = policiesToRender.filter((policy) => policy.isActive === false);
      if (closedPolicies.length > 0) {
        this.showClosedDisabled = false;
      }
      if (!this.showClosed) {
        policiesToRender = policiesToRender.filter((policy) => policy.isActive === true);
      }
      this.numberOfPolicies = policiesToRender.length;
      if (policiesToRender.length > 5 && !this.showAll) {
        policiesToRender = policiesToRender.slice(0, 5);
      }
      // if all policies are closed
      if (
        policiesToRender.length === 0 &&
        closedPolicies.length > 0 &&
        !this.showClosedUserChanged
      ) {
        this.showClosed = true;
        if (closedPolicies.length > 5 && !this.showAll) {
          this.numberOfPolicies = closedPolicies.length;
          return closedPolicies.slice(0, 5);
        }
        return closedPolicies;
      }
      return policiesToRender;
    },
    noOpenPolicies() {
      if (this.policies.length === 0) {
        return true;
      }
      if (this.policies.length > 0 && this.openPolicies.length === 0 && !this.showClosed) {
        return true;
      }
    },
  },
  methods: {
    toggleShowAll() {
      this.showAll = !this.showAll;
    },
    toggleShowClosed(props) {
      this.showClosedUserChanged = true;
    },
    hasBanner() {
      if (this.apiBanners == null || typeof this.apiBanners == 'undefined') return false;
      return this.apiBanners.length > 0;
    },
  },
};
